import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCco5iR98OSW_Jujby4V9sXVO6EtNJYhmU",
  authDomain: "bridgefy-sdk-staging.firebaseapp.com",
  projectId: "bridgefy-sdk-staging",
  storageBucket: "bridgefy-sdk-staging.appspot.com",
  messagingSenderId: "663062841576",
  appId: "1:663062841576:web:21fb93a07045babd33a15d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
